export default __webpack_public_path__ + "46c9fb2688819e66cd285c406ed000d1.svg";